/* C */
export const CONDO_MANAGEMENT_PAGE_CLICKED = 'CONDO_MANAGEMENT_PAGE_CLICKED';

/* D */
export const DELETE_SUPPLEMENT = 'DELETE_SUPPLEMENT';

/* F */
export const FORM_VALUES = 'FORM_VALUES';

/* G */
export const GET_ALL_LISTINGS = 'GET_ALL_LISTINGS';
export const GET_ALL_LISTINGS_FAIL = 'GET_ALL_LISTINGS_FAIL';
export const GET_ALL_LISTINGS_SUCCESS = 'GET_ALL_LISTINGS_SUCCESS';

/* L */
export const LOAD_SUBFORM_DATA = 'LOAD_SUBFORM_DATA';
export const LISTING_SEARCH_CLICKED = 'LISTING_SEARCH_CLICKED';
export const LOAD_LISTING = 'LOAD_LISTING';
export const LOAD_LISTING_FAIL = 'LOAD_LISTING_FAIL';
export const LOAD_LISTING_SUCCESS = 'LOAD_LISTING_SUCCESS';
export const LOAD_LISTING_PREFERRED_PHOTO_DETAILS = 'LOAD_LISTING_PREFERRED_PHOTO_DETAILS';
export const LOAD_LISTING_PREFERRED_PHOTO_DETAILS_FAIL = 'LOAD_LISTING_PREFERRED_PHOTO_DETAILS_FAIL';
export const LOAD_LISTING_PREFERRED_PHOTO_DETAILS_SUCCESS = 'LOAD_LISTING_PREFERRED_PHOTO_DETAILS_SUCCESS';
export const LOAD_LISTING_PHOTO = 'LOAD_LISTING_PHOTO';
export const LOAD_LISTING_PHOTO_FAIL = 'LOAD_LISTING_PHOTO_FAIL';
export const LOAD_LISTING_PHOTO_SUCCESS = 'LOAD_LISTING_PHOTO_SUCCESS';
export const LOAD_UPLOADED_PHOTOS = 'LOAD_UPLOADED_PHOTOS';

/* R */
export const REORDER_SUPPLEMENTS = 'REORDER_SUPPLEMENTS';

/* S */
export const SAVE_IMAGES = 'SAVE_IMAGES';
export const SAVE_SUPPLEMENT = 'SAVE_SUPPLEMENT';
export const SAVE_SUPPLEMENT_SUCCESS = 'SAVE_SUPPLEMENT_SUCCESS';
export const SAVE_SUPPLEMENT_FAIL = 'SAVE_SUPPLEMENT_FAIL';
export const SEARCH_LISTINGS = 'SEARCH_LISTINGS';
export const SEARCH_LISTINGS_CRITERIA = 'SEARCH_LISTINGS_CRITERIA';

/* T */
export const TAX_AUTO_POP_SEARCH = 'TAX_AUTO_POP_SEARCH';
export const TAX_AUTO_POP_SEARCH_FAIL = 'TAX_AUTO_POP_SEARCH_FAIL';
export const TAX_AUTO_POP_SEARCH_SUCCESS = 'TAX_AUTO_POP_SEARCH_SUCCESS';
export const TAX_AUTO_POP_SELECT = 'TAX_AUTO_POP_SELECT';
export const TAX_AUTO_POP_SELECT_FAIL = 'TAX_AUTO_POP_SELECT_FAIL';
export const TAX_AUTO_POP_SELECT_SUCCESS = 'TAX_AUTO_POP_SELECT_SUCCESS';

/* V */
export const VIEW_LISTING_CLICKED = 'VIEW_LISTING_CLICKED';
